import * as React from "react"
import { batch } from "@preact/signals-react"
import { SwitchSeeker } from "@ui-seeker/core"

import { useAdminNewListedForm } from "../../../@hooks"
import { adminNewListedTableData, adminNewListedSkuMappingData } from "../../../@signals"


export default function validatedColumn(isSkuMappingTable = false) {
	return {
		name: 'validated',
		label: 'Validated',
		options: {
			setCellProps: () => ({ sx: { textAlign: 'center' } }),
			filter: false,
			customBodyRowRenderLite: (value, rowData) => <ValidatedCell rowData={rowData} isSkuMappingTable={isSkuMappingTable}  />
		}
	}
}

const ValidatedCell = ({ rowData, isSkuMappingTable }) => {
	const { handleSendToBack } = useAdminNewListedForm(rowData)
    
	return <SwitchSeeker
		formControlProps={{sx: {margin: '0 auto'}}}
		checked={!!rowData?.validated}
		onChange={() => batch(() => {
			handleSendToBack({validated: !rowData?.validated}, {
				onSuccess: newRow => {
					if (!isSkuMappingTable) {
						adminNewListedTableData.value = adminNewListedTableData.value
						.map(row => row.id === newRow.id ? newRow : row)
					} else {
						adminNewListedSkuMappingData.value = adminNewListedSkuMappingData.value
						.map(row => row.id === newRow.id ? newRow : row)
					}
					return 'Data loaded'
				}
			})
		})}
	/>
}